/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { CatalogDashboard } from "@app/api/trpc/routers/catalog";

type Props = { setup: CatalogDashboard["setup"] };

// Share of sellable products with each piece of setup done.
export const MenuCompleteness = defineComponent<Props>({
  name: "MenuCompleteness",
  props: ["setup"],
  setup(props) {
    const { t } = useLocalization();

    return () => {
      const s = props.setup;
      const rows = [
        { key: "with_category", icon: "folder", done: s.with_category },
        { key: "with_price", icon: "sell", done: s.with_price },
        { key: "with_image", icon: "image", done: s.with_image },
        ...(s.tracks_stock ? [{ key: "with_recipe", icon: "receipt_long", done: s.with_recipe }] : []),
      ];
      return (
        <ul class="space-y-3">
          {rows.map((r) => {
            const pct = s.sellable > 0 ? (r.done / s.sellable) * 100 : 0;
            return (
              <li key={r.key}>
                <div class="flex items-center gap-2 text-sm">
                  <span class="material-symbols-outlined text-base text-base-content/40">{r.icon}</span>
                  <span class="flex-1 text-accent">{t(`catalog.overview.${r.key}`)}</span>
                  <span class="text-xs tabular-nums text-base-content/60">{`${r.done} / ${s.sellable}`}</span>
                </div>
                <div class="mt-1 h-1.5 overflow-hidden rounded-full bg-base-200">
                  <div
                    class={["h-full rounded-full", pct >= 90 ? "bg-success" : pct >= 50 ? "bg-warning" : "bg-error"].join(" ")}
                    style={{ width: `${pct}%` }}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      );
    };
  },
});
